/**
 * Service names and the words that go with them — MTC-FCS-052.
 * ============================================================================
 * GENERATED by scripts/build-service-copy.js from data/services-organized.json.
 * Do not edit by hand: rerun `npm run services` instead, or the next run will
 * quietly throw the edit away.
 *
 * Shape: trade slug -> service name -> every description written for it. A
 * service with more than one is why step three has a regenerate button — the
 * contractor cycles the wordings rather than being handed one and left to
 * argue with it.
 *
 * TRADE_COPY is what the drop said about the trade itself, used when the only
 * service on offer is the trade's own name.
 */

export const SERVICE_COPY = {
  "cabinetry": {
    "Cabinet Finishes": [
      "Expert staining and finishing services for cabinets, enhancing their appearance and durability with a high-quality, custom look.",
    ],
    "Cabinet Refinishing": [
      "Revitalize your kitchen or bathroom with custom cabinet refinishing that breathes new life into worn-out cabinetry.",
    ],
    "Cabinets": [
      "We specialize in premium cabinet installations, providing expert craftsmanship and personalized designs for residential projects.",
    ],
    "Carpenter": [
      "Expert in woodworking and construction, providing services like furniture building, cabinetry installation, and structural repairs.",
    ],
    "Custom Cabinet": [
      "Exquisite craftsmanship delivering custom cabinets and built-in solutions tailored to your specific needs.",
    ],
    "Entertainment Centers": [
      "We provide luxurious custom cabinetry solutions for entertainment centers, combining exquisite craftsmanship and premium materials for unparalleled sophistication and functionality.",
    ],
  },
  "carpentry": {
    "And More": [
      "Enhance the beauty and functionality of your home with our wide-ranging carpentry services, from custom door repairs to intricate crown molding, stairs, and more.",
    ],
    "Custom Woods": [
      "Tailored designs for closets and entertainment centers, maximizing functionality and style to suit your unique needs and space.",
    ],
    "Finish Carpentry": [
      "Expert finish carpentry services, including trim work, cabinetry, and custom woodwork, ensuring a polished and refined look for your interior spaces.",
    ],
    "General Carpentry": [
      "Skilled carpentry services encompassing doors, windows, decks, and wood siding to enhance the functionality and aesthetics of your property.",
    ],
    "Hedge Trimming": [
      "Precision edge trimming to keep your lawn borders clean, neat, and well-defined, enhancing overall landscape aesthetics.",
    ],
    "Inside Trim": [
      "Precision interior trim work to enhance spaces, offering customized solutions for a polished and cohesive interior design aesthetic.",
    ],
    "Interior Exterior Trim": [
      "Enhance your spaces with precision-crafted crown molding and trim for a polished and elegant finish.",
    ],
    "Interior Finish Work": [
      "Complete interior spaces with precise installation of trim, moldings, doors, and other finishing touches for a polished look.",
    ],
    "Prune Trimming": [
      "Expert prune trimming to maintain healthy, attractive trees and shrubs, promoting growth and preventing overgrowth.",
    ],
    "Trim & Baseboard": [
      "Our team installs new trim and baseboards, including painting the baseboards white, enhancing your space with a polished finish.",
    ],
    "Trim & Moldings": [
      "Expert installation of decorative trim and moldings, adding elegance, character, and detail to your interior spaces.",
    ],
    "Woodwork": [
      "We specialize in crafting bespoke furniture, cabinetry, and decorative pieces, enhancing spaces with timeless elegance and functionality.",
    ],
  },
  "cleaning": {
    "Commercial Cleaning": [
      "Professional cleaning services for offices, retail spaces, and commercial buildings, maintaining a clean, healthy, and productive work environment.",
    ],
    "Duct Cleaning": [
      "Specialized cleaning for air ducts to enhance air quality and system efficiency without distinction between residential and commercial areas.",
    ],
    "Estate Clean-Outs": [
      "Comprehensive removal of items from homes during transitions, helping with downsizing, relocations, or clearing out estates efficiently.",
    ],
    "Garage Clean-Outs": [
      "Clear out cluttered garages, removing old tools, equipment, and junk to create a functional, organized space for storage.",
    ],
    "Junk Removal": [
      "Efficiently remove unwanted items like furniture, appliances, and clutter, leaving your space clean, organized, and stress-free.",
    ],
    "Residential & Airbnb": [
      "A comprehensive cleaning service tailored for short-term rental properties, ensuring homes are spotless and guest-ready between bookings.",
    ],
    "Shed Teardowns": [
      "Expert demolition and removal of sheds, ensuring safe teardown, proper disposal of materials, and leaving your space clean.",
    ],
    "Storage Clean-Outs": [
      "Organize and clean out storage units, removing unwanted items, sorting belongings, and responsibly disposing of or donating unused items.",
    ],
  },
  "concrete": {
    "And More": [
      "We offer specialized services including exposed aggregate, showcasing the natural beauty of stone within the concrete surface.",
    ],
    "Bible Heritage": [
      "Delves into biblical teachings, traditions, and values that have influenced societies, providing spiritual guidance and moral foundations throughout history.",
    ],
    "Commercial": [
      "Elevate your commercial projects with our comprehensive concrete services tailored specifically for the demands of the commercial sector.",
    ],
    "Concrete & Asphalt": [
      "Specialized services offering concrete, seal coating, and asphalt shingle roofing solutions for residential and commercial properties, ensuring enhanced durability.",
    ],
    "Concrete and Gravel": [
      "Our skilled team specializes in the installation of durable and versatile concrete and gravel surfaces, offering long-lasting solutions for various applications.",
    ],
    "Decorative Concrete": [
      "Decorative concrete transforms surfaces with stamping, staining, and polishing techniques, offering endless design possibilities for indoor and outdoor spaces.",
    ],
    "Driveway": [
      "Install durable and professionally finished driveways that ensure both practicality and visual appeal for residential and commercial properties alike.",
    ],
    "Driveways & Roads": [
      "Building and maintaining durable driveways and roads, enhancing accessibility and providing long-lasting, smooth surfaces for residential and commercial properties.",
    ],
    "Hardscape": [
      "Comprehensive hardscape solutions, including the design and installation of walkways, patios, and driveways, creating functional and attractive outdoor spaces.",
    ],
    "Hardscapes": [
      "Transform outdoor spaces with expert concrete work, driveways, and patio installations for functional and visually appealing results.",
    ],
    "Indoor": [
      "We specialize in indoor concrete services, transforming basements and garages into functional, durable spaces.",
    ],
    "Outdoor": [
      "We excel in outdoor concrete solutions, crafting stunning driveways and patios that withstand the elements. Our expert team combines precision and creativity to deliver durable, visually appealing outdoor spaces.",
    ],
    "Residential": [
      "Transform your residential projects with our specialized concrete services designed to enhance the beauty and functionality of your home.",
    ],
    "Volumetric Mixing": [
      "Discover our cutting-edge concrete services featuring Volumetric Mixing technology. With our innovative approach, we can mix on-site, catering precisely to your project requirements.",
    ],
  },
  "demolition": {
    "Demolition & Trash Removal": [
      "With utmost care and precision, we handle demolition projects, safely tearing down buildings, removing sheds, demolishing walls, and clearing land for your remodeling or development needs.",
    ],
  },
  "drywall": {
    "Commerical": [
      "Our commercial drywall service offers expert installation, repair, and finishing, including drop ceiling solutions, for durable and professional business spaces.",
    ],
    "Drywall Repair": [
      "Our skilled technicians install or repair your drywall with precision. This service comes with a one-year guarantee for peace of mind.",
    ],
    "Drywall Repairs & More": [
      "Our additional services include, drywall/stucco repair, and epoxy flooring, patching, seamless filling ensuring flawless restoration and lasting quality.",
    ],
    "Patches": [
      "Professional patching services to repair holes, cracks, and other imperfections in your drywall, restoring surfaces to like-new condition.",
    ],
    "Residential": [
      "Our residential drywall service delivers expert installation, repair, and finishing for homeowners, ensuring smooth, durable walls and ceilings.",
    ],
  },
  "electrical": {
    "Commercial": [
      "Commercial electrical services encompass a range of electrical solutions tailored specifically for businesses and commercial properties.",
    ],
    "Heritage Connections": [
      "Bridges the relationship between American history and biblical heritage, highlighting shared values of faith, freedom, and the pursuit of truth.",
    ],
    "Residential": [
      "Residential electrical services involve a range of electrical solutions tailored to meet the needs of homeowners and their properties.",
    ],
  },
  "excavation": {
    "Excavation & Groundwork": [
      "Our excavation and groundwork services encompass the precise excavation required for septic tanks, foundations, and essential infrastructure, ensuring optimal support for your projects.",
    ],
  },
  "exteriors": {
    "Deck Building": [
      "Create the perfect outdoor retreat with our expert deck building services, tailored to your design preferences and lifestyle.",
    ],
    "Deck Staining": [
      "High-quality staining services for decks to enhance color, protect the wood, and improve resistance to weathering and wear.",
      "Specialized deck staining services, providing a beautiful and protective finish that enhances durability and extends the life of your deck.",
    ],
    "Decking": [
      "Elevate your outdoor spaces with the perfect blend of beauty and functionality through our durable Trex Pro Rexlon and cedar decking.",
    ],
    "Decks": [
      "Construct and repair decks, providing beautiful and durable outdoor living spaces for relaxation and entertainment.",
      "Custom deck design and construction to extend your living area outdoors, providing durable and attractive entertainment spaces.",
      "Custom deck design and construction, creating beautiful outdoor spaces for relaxation, entertainment, and enjoying the outdoors.",
      "Design and build custom decks for residential properties, creating beautiful, functional outdoor spaces that enhance your home’s appeal.",
      "Design and build custom decks, creating beautiful, durable outdoor living spaces for relaxation and entertainment.",
      "Design and build custom decks, enhancing outdoor spaces with durable, attractive, and functional structures for relaxation and entertainment.",
      "Enhance your outdoor living space with our expert deck construction, providing custom designs, durable materials, and skilled craftsmanship for a perfect retreat.",
      "Enhance your outdoors with durable Trex Pro Rexlon decking, melding beauty and functionality for stunning outdoor spaces.",
      "Transform your outdoor space into a breathtaking oasis with our premier deck building services. We specialize in crafting custom decks tailored to your unique vision and lifestyle.",
    ],
    "Exterior": [
      "Quality exterior upgrades, including siding, decks, and repairs, designed to improve durability, curb appeal, and property value.",
    ],
    "Exterior Doors": [
      "Professional installation of durable, stylish exterior doors, enhancing security, energy efficiency, and curb appeal for your home or business.",
    ],
    "Exterior Wash": [
      "Professional exterior washing services, effectively removing dirt and grime to restore the cleanliness and appearance of your home's exterior surfaces.",
    ],
    "Metal Siding": [
      "High-quality metal siding that enhances the appearance and durability of buildings. Resistant to impact, fire, and pests, ensuring low maintenance and longevity.",
    ],
    "New Decks": [
      "Beautiful composite decks are designed and built to perfection, creating stunning outdoor living spaces for your enjoyment.",
    ],
    "Outdoor Structures": [
      "Transform your home with precision through our top-notch renovations, adding value and enhancing your living experience.",
    ],
    "Patio": [
      "Design and construct functional and stylish outdoor living spaces, tailored to meet your specific residential or commercial needs.",
    ],
    "Patio Covers": [
      "Customized exteriors, including expertly crafted gazebos, pergolas, and more, enhance the aesthetics and functionality of your home.",
      "Enhance your outdoor living with our custom patio covers, providing stylish protection from the elements while adding value and comfort.",
    ],
    "Patios": [
      "Professional patio design and installation, creating beautiful and functional outdoor living spaces tailored to your needs.",
      "Transform your outdoor space into a haven of relaxation and entertainment with our premier patio building services. From concept to completion, our skilled team brings expertise and creativity to every project.",
    ],
    "Patios/Driveways": [
      "Our concrete services specialize in crafting high-end patios and driveways, ensuring top-quality finishes for luxurious outdoor living spaces.",
    ],
    "Pergolas": [
      "Add charm and shade to your backyard with our custom pergolas, perfect for enhancing your outdoor living space.",
      "Elevate your outdoor living experience with our pergola building services. Crafted with precision and attention to detail, our pergolas seamlessly blend beauty and functionality.",
    ],
    "Power Washing": [
      "Professional power washing services, effectively removing dirt, grime, and stains to restore the appearance of your surfaces.",
      "Restore the beauty of your surfaces with our thorough power washing services, removing dirt, grime, and stains effectively and efficiently.",
    ],
    "Screened-In Porches": [
      "Enhance your outdoor space with our deck and custom exteriors business, offering drainage solutions, lighting, built-in seating, and more.",
      "Enjoy the outdoors bug-free with our elegant screened-in porches, offering comfort and protection in any weather.",
    ],
    "Siding": [
      "Comprehensive siding solutions, including paint grade and metal options, designed to protect, insulate, and elevate your home’s appearance.",
      "Installation and repair of exterior siding to protect and enhance the appearance of homes and buildings with durable materials.",
      "Professional siding installation and repair, enhancing your home's appearance and providing long-lasting protection from the elements.",
      "We offer top-tier siding services to transform and protect your home. With a focus on quality craftsmanship and attention to detail, our expert team ensures flawless installations and repairs.",
    ],
    "Siding and Windows": [
      "Install high-quality siding and energy-efficient windows, enhancing your home’s appearance, insulation, and overall value.",
    ],
    "Windows": [
      "Quality window installation and replacement to improve energy efficiency, natural lighting, and the overall aesthetics of your home.",
      "We offer top-notch window installation services to enhance your home's comfort, energy efficiency, and curb appeal.",
    ],
  },
  "fencing": {
    "Fence Building": [
      "Enhance privacy and security with our professional fence building solutions, utilizing quality materials and expert craftsmanship.",
    ],
    "Fence Restoration": [
      "Revitalizing wooden fences and porches through expert cleaning, repairs, and protective treatments to restore their beauty and durability.",
    ],
    "Repaired Fences": [
      "Expert fence repairs for commercial and residential properties, restoring security and aesthetics.",
    ],
  },
  "flooring": {
    "Carpet": [
      "Elevate your space with our premium carpet purchase and installation services. Choose from a wide selection of luxurious carpets that not only speak to your style but also stand the test of time in terms of durability.",
      "Experience our comprehensive carpet installation services, where precision meets professionalism.",
      "Step into our showroom and experience firsthand the limitless possibilities that come from choosing the perfect carpet for your home.",
    ],
    "Epoxy": [
      "We specialize in creating high-end epoxy surfaces, delivering top-notch quality and durability for luxurious and stunning indoor flooring solutions.",
    ],
    "Epoxy Floors": [
      "Expert epoxy coating for garage floors, providing a durable, attractive, and easy to maintain surface for high traffic areas.",
    ],
    "Epoxy Garage Floors": [
      "Durable and attractive epoxy flooring solutions for garages, providing a resistant, easy-to-clean surface that withstands heavy use.",
    ],
    "Floors": [
      "Professional installation of luxury vinyl planks, carpet, and hardwood flooring for a stylish and durable finish in any room.",
    ],
    "Hardwood": [
      "Embark on a sensory journey In our showroom where you can witness the unparalleled quality of our engineered hardwood floors. Seeing is believing, and our exquisite finishes deserve to be experienced firsthand.",
      "Immerse yourself in sophistication with our premium Hardwood purchase and installation services. Our carefully curated collection of top-notch hardwoods effortlessly blends elegance and resilience for your space.",
      "Transform your home with our comprehensive hardwood flooring installation solutions. Admired for its durability and timeless appeal, hardwood flooring effortlessly enhances any space.",
    ],
    "Hardwood & LVP": [
      "Experience the epitome of craftsmanship with our hardwood work. We are dedicated to delivering the finest in hardwood & LVP installations.",
    ],
    "Laminate": [
      "Step into a world of sophistication with our premium Laminate purchase and installation services. Our curated selection of high-quality laminates offers a perfect blend of style and durability for your space.",
      "Today's Laminate floors offer wood looks that emulate the warmth and beauty of hardwood floors.",
    ],
    "Luxury Vinyl Plank": [
      "A flooring option that combines elegance, durability and affordability brings us to Luxury Vinyl Flooring.",
    ],
    "LVP": [
      "We are your destination for exceptional Luxury Vinyl Plank (LVP) purchase and installation services. Explore a diverse selection of LVP options that seamlessly combine style and durability.",
    ],
    "LVP & Vinyl": [
      "Experience effortless space revamping with our luxury vinyl plank (LVP) flooring installation solutions.",
    ],
    "Stretching": [
      "By addressing these issues promptly, we not only enhance the aesthetic appeal of your space but also extend the lifespan of your carpets.",
    ],
    "Vinyl Flooring": [
      "Expertly laid, our luxury vinyl plank flooring seamlessly transforms spaces, offering durability, style, and easy maintenance for lasting satisfaction.",
    ],
  },
  "general": {
    "3D Printing": [
      "Unlock limitless possibilities with our advanced 3D printing services, where expertise to bring your designs to life.",
    ],
    "American Heritage": [
      "Explores the founding principles, cultural evolution, and key historical events that shaped the United States, emphasizing freedom and democracy.",
    ],
    "Area Rugs": [
      "Elevate your space with our exquisite selection of stylish area rugs or create a custom area rug in a specific size and shape based on your personal style.",
    ],
    "Autocad Drafting & Design": [
      "Accurate technical drawings and designs using AutoCAD software for architectural, engineering, and mechanical projects.",
    ],
    "Basements": [
      "From framing to finishing, we create spaces in your basement that are tailored to your needs while increasing your home's value.",
    ],
    "Blackberry and Poison Ivy Removal": [
      "Reclaim your property from invasive plants with our efficient removal services, restoring its beauty and creating a safe environment for you to enjoy.",
    ],
    "Boat/RV Storage": [
      "Our private boat/RV storage offers the town's most affordable rates, at half the price of competitors, ensuring cost-effective and secure storage solutions.",
    ],
    "Chimney": [
      "Expert chimney construction and repair, ensuring safe, efficient, and durable chimneys for both residential and commercial properties.",
    ],
    "Construction": [
      "New construction electrical services involve the design, installation, and integration of electrical systems in buildings that are under construction or undergoing significant renovations.",
      "Post-construction cleaning service that removes debris, dust, and leftover materials, leaving new construction sites pristine and ready for use.",
      "We specialize in premium tile and stone installations, providing expert craftsmanship and personalized designs for residential projects.",
    ],
    "Consulting Design": [
      "We provide expert design consultation for interior and exterior spaces, creating cohesive and aesthetically pleasing environments.",
    ],
    "Custom Exteriors": [
      "Customized exteriors are expertly crafted to enhance the aesthetics and functionality of your home, reflecting your unique style.",
    ],
    "Custom Homes": [
      "Crafting unique, high-quality custom homes tailored to your vision, incorporating personalized design features and superior craftsmanship for ultimate satisfaction.",
      "Customize your home with our exquisite tile and stone installations, tailored to suit your unique style and preferences, ensuring exceptional results.",
      "We specialize in custom home building, offering personalized services to guide you every step of the way, from concept to completion of your dream home.",
    ],
    "Decorative": [
      "Enhance your space with expertly crafted flatwork designs, adding aesthetic appeal and durability to commercial and residential properties.",
    ],
    "Decorative Plaster": [
      "Elevate your space with our exquisite decorative plaster services, mimicking the luxurious look of marble for a sophisticated finish.",
    ],
    "Design": [
      "Elevate your vehicle's style with our customizable car wraps! Collaborate with our talented design team to bring your vision to life, ensuring your wrap reflects your unique personality or brand identity.",
    ],
    "Design & Decorating": [
      "Our interior decorating services provide tasteful designs, premium furnishings, and personalized touches for a stylish living environment.",
    ],
    "DIY Options": [
      "Experience the convenience of our car wrap installation options! Trust our skilled team to professionally install your wrap with precision and care, or opt for our DIY kits and take the creativity into your own hands.",
    ],
    "Doors": [
      "Expert door installation and replacement services for increased security, functionality, and curb appeal.",
    ],
    "Finishing": [
      "Achieve a flawless and professional look with our expert finishing services, ensuring smooth surfaces and impeccable detailing.",
    ],
    "Garages & Sheds": [
      "Designing and constructing custom garages and sheds, offering secure and functional storage solutions tailored to your specific needs.",
    ],
    "General Contractor": [
      "Expert roofing services for new residential construction, ensuring quality, durability, and aesthetic appeal from the start.",
      "Oversees construction projects from start to finish, managing schedules, budgets, subcontractors, and materials to ensure quality and timely completion.",
    ],
    "Installation": [
      "Trust our skilled team for efficient and precise installation, delivering quality results for your project's specific requirements.",
    ],
    "Marketing": [
      "Transform your vehicle into a powerful marketing tool with our car wraps. Studies reveal that vehicle wraps generate up to 70,000 impressions per day, delivering unparalleled exposure for your brand.",
    ],
    "Mattress Recycling": [
      "Eco-friendly removal and recycling of old mattresses, ensuring responsible disposal and helping to reduce environmental waste.",
    ],
    "Moving Services": [
      "Professional moving assistance, including packing, loading, and transport, making your relocation smooth, efficient, and stress-free.",
    ],
    "New Construction": [
      "Build new homes from the ground up, ensuring quality craftsmanship and attention to detail for a personalized living space.",
      "Build your dream home from the ground up with our new construction services, combining innovative design, quality materials, and precise construction for a personalized living experience.",
      "Building innovative and custom structures from the ground up, delivering exceptional quality and craftsmanship for your dream project.",
      "Comprehensive new construction services, delivering custom-built homes with superior craftsmanship and attention to detail.",
      "Construct new additions, garages, and pole barns with attention to detail, enhancing your property with functional and durable structures.",
      "Elevate the craftsmanship of your new construction project with our skilled carpentry services, delivering custom cabinetry, and finishing touches to perfection.",
      "Elevate your living with our expertly crafted new structures, from versatile decks to cozy guest houses and innovative modular homes.",
      "From concept to completion, we excel in constructing custom structures with precision, innovation, and attention to detail.",
      "New builds, additions, and custom projects with exceptional craftsmanship, ensuring durability and quality construction.",
      "Professional painting for new builds, ensuring a flawless finish that complements the fresh architecture.",
      "Professional roofing solutions for new builds, providing top-quality materials and expert installation tailored to your construction needs.",
      "We offer reliable and efficient new construction services to address all your needs with precision & professionalism.",
    ],
    "Patching": [
      "Filling and blending damaged areas seamlessly with surrounding materials to maintain structural integrity and aesthetic continuity.",
    ],
    "Powder Coating": [
      "Elevate your metal finishes with our premium powder coating services, where durability meets aesthetics to redefine surface excellence.",
    ],
    "Repair": [
      "Fixing damaged areas to restore functionality and appearance, ensuring long-lasting solutions for various structural components.",
    ],
    "Restoring": [
      "Bringing back original condition or enhancing surfaces through precise repair, and preservation methods for lasting beauty.",
    ],
    "Rot Repair": [
      "Comprehensive rot repair services to restore structural integrity and protect your home from further damage.",
    ],
    "Shed and Shop Building": [
      "Let us bring your vision to life with our custom construction services, creating functional and aesthetically pleasing sheds and shops that meet your unique needs.",
    ],
    "Steel Framing": [
      "Expert installation of durable, cost-effective steel framing for commercial buildings, ensuring structural integrity and long-lasting performance.",
    ],
    "Steps": [
      "Expert construction and repair of steps, ensuring safety, durability, and aesthetic appeal for residential and commercial properties.",
    ],
    "Veneers": [
      "High quality veneer installations, providing enhanced appearance, durability, and protection for a variety of wall surfaces.",
    ],
    "Ventilation": [
      "Thorough upkeep for ventilation systems, maintaining indoor air quality and system efficiency to foster healthier environments.",
    ],
  },
  "handyman": {
    "Doors": [
      "Professional door services, including installation, repair, and maintenance, for seamless functionality and enhanced security.",
    ],
    "Light Repair": [
      "Skilled light repair services, addressing minor damages and ensuring the functionality and aesthetics of your fixtures and surfaces.",
    ],
    "Maintenance": [
      "Comprehensive roof inspections and maintenance services, ideal for realtors and homeowners, ensure roofs are in excellent condition for sale or longevity.",
      "Our dedicated team excels in providing meticulous HVAC maintenance services to keep your systems running at peak performance.",
      "Reliable commercial and residential solutions to keep your property in top shape, ensuring functionality and longevity.",
      "We are your dedicated partner in preserving the longevity and resilience of your roofing investment. We set ourselves apart as the go-to solution for comprehensive roofing maintenance services.",
    ],
    "Priming and Repairs": [
      "From patchwork and repairs to priming, our meticulous prep-work sets the foundation for a seamless and long-lasting finish.",
    ],
    "Property Care": [
      "Comprehensive service maintains and repairs properties, ensuring they're in optimal condition for resale or rental purposes.",
    ],
    "Repairs": [
      "Our drywall repair service specializes in fixing cracks, holes, and damage, restoring walls and ceilings to pristine condition efficiently.",
      "Prompt and reliable roof repair services address leaks, storm damage, and wear to restore your roof's functionality and appearance.",
      "Restore the integrity and beauty of your carpets with our top-notch carpet repair service.",
      "We pride ourselves on prompt and reliable HVAC repair services. Our skilled technicians are equipped to swiftly diagnose and resolve issues, ensuring your heating, ventilation, and air conditioning systems operate.",
    ],
    "Repairs & More": [
      "Our repair services for high-end homes encompass meticulous patching, seamless filling, and comprehensive repairs, ensuring flawless restoration and lasting quality.",
    ],
    "Weekly Maintenance": [
      "Comprehensive weekly maintenance to keep your landscape looking pristine, including mowing, trimming, and general upkeep.",
    ],
  },
  "hvac": {
    "Boiler": [
      "Specializing in boiler repairs, our team offers swift, professional service to ensure optimal heating performance and customer satisfaction.",
    ],
    "Complete HVAC Care": [
      "Holistic care for heating, ventilation, and air conditioning needs, ensuring top-tier service and system performance for all clients.",
    ],
    "Emergency HVAC": [
      "Prompt and reliable emergency repair services for heating, ventilation, and air conditioning systems in times of unexpected malfunctions.",
    ],
    "HVAC Services": [
      "Comprehensive heating, ventilation, and air conditioning solutions to ensure optimal indoor comfort and climate control in various settings.",
    ],
    "Refrigeration": [
      "Tailored cooling solutions for various needs, ensuring precise temperature control and preservation of perishable goods in diverse environments.",
    ],
    "Replacement": [
      "We specialize in expert HVAC replacement services, ensuring seamless upgrades for your heating, ventilation, and air conditioning systems.",
    ],
  },
  "landscaping": {
    "Bark Installation": [
      "Enhance the visual appeal and functionality of your landscaping with our meticulous bark installation services, providing a polished and cohesive look to your outdoor areas.",
    ],
    "Irrigation": [
      "Comprehensive irrigation services, including commercial and agricultural casing pipe installations for optimal landscape maintenance.",
    ],
    "Irrigation & More": [
      "Comprehensive landscaping services, including efficient sprinkler systems, to keep outdoor areas vibrant and well-maintained.",
    ],
    "Lawn Care": [
      "Our expert team provides comprehensive lawn care services including mowing, precise edging, trimming, fertilizing, weed control, and seasonal cleanups for a perfect yard.",
    ],
    "Mulch": [
      "Professional mulch installation to retain soil moisture, suppress weeds, and enhance the appearance of your garden beds.",
    ],
    "New Lawn Installation": [
      "Achieve a vibrant and healthy lawn with our professional installation services, utilizing seed, sod, or hydro-seeding methods to ensure optimal results and a lush outdoor space.",
    ],
    "Tree Services": [
      "Our comprehensive tree and stump removal service efficiently eliminates unwanted vegetation and roots, leaving your landscape pristine and hazard-free.",
    ],
  },
  "masonry": {
    "Fireplace": [
      "Custom fireplace construction and restoration, providing warmth, charm, and a focal point for your indoor or outdoor spaces.",
    ],
    "Retaining Wall": [
      "Construct sturdy retaining walls to prevent erosion, manage slopes, and add structural integrity and aesthetic appeal to landscapes.",
    ],
    "Retaining Walls": [
      "Constructing durable and aesthetically pleasing retaining walls, providing essential landscape support, erosion control, and enhanced outdoor space appeal.",
    ],
  },
  "painting": {
    "And More": [
      "In addition to our core offerings, we provide exterior painting, cosmetic upgrades, and more.",
    ],
    "Cabinet Repainting": [
      "Expert cabinet repainting services to refresh and revitalize your kitchen or bathroom, providing a durable and attractive new finish.",
    ],
    "Commercial": [
      "Our commercial painting service delivers superior quality for both interior and exterior projects, ensuring durable finishes and meticulous attention to detail.",
      "We specialize in commercial painting services, providing high-quality finishes, color consulting, and efficient project management for businesses and commercial properties.",
      "Whether it's painting exterior walls and trim or applying protective coatings for superior weather resistance and durability, we've got you covered.",
    ],
    "Exterior": [
      "Our residential exterior painting service delivers top-tier quality, enhancing homes with expert precision, vibrant colors, and durable finishes, including stucco surfaces.",
      "Protect and beautify your home’s exterior with durable, high-quality paint that enhances curb appeal.",
    ],
    "Exterior Painting": [
      "Crafted for both commercial and residential, our exterior painting services epitomize durability and meticulous attention to detail, ensuring lasting beauty and sophistication.",
      "Crafted for high-end residences, our exterior painting services epitomize elegance, durability, and meticulous attention to detail, ensuring lasting beauty and sophistication.",
      "Durable exterior painting solutions designed to protect your property and boost curb appeal with weather-resistant, flawless finishes.",
      "Enhancing curb appeal and protecting surfaces with durable coatings, ensuring long-lasting beauty and weather resistance.",
      "Our exterior painting services epitomize elegance, durability, and meticulous attention to detail, ensuring lasting beauty and sophistication.",
      "Professional exterior painting, improving curb appeal and protecting your property from the elements with durable and high-quality finishes.",
    ],
    "Farm & Ranch": [
      "We understands the unique needs of farms and ranches, offering painting solutions that protect and enhance agricultural structures, barns, fences, and equipment with long-lasting coatings.",
    ],
    "Industrial": [
      "Our industrial painting services cater to industrial facilities, offering durable coatings, corrosion protection, surface preparation, and expertise in handling specialized industrial coatings.",
    ],
    "Interior": [
      "Our residential interior painting service ensures premium quality, rejuvenating homes with meticulous attention to ceilings, cabinets, and trim for lasting beauty.",
      "Transform your living space with expert interior painting, adding warmth, style, and personality to every room.",
    ],
    "Interior Painting": [
      "High quality painting services for both interiors and exteriors, enhancing your property’s appearance and durability.",
      "High-quality interior painting services to refresh and enhance your home's ambiance with precision and attention to detail.",
      "Our interior painting service transforms spaces with expert techniques, high-quality paints, and meticulous attention to detail for stunning results.",
      "Our interior painting services embody sophistication, meticulous attention to detail, and an unwavering dedication to unparalleled luxury and refinement.",
      "Our interior painting services for high-end homes epitomize sophistication, meticulous attention to detail, and a commitment to unparalleled luxury and refinement.",
      "Our interior painting services for residential and commercial spaces epitomize sophistication, meticulous attention to detail, and a commitment to unparalleled craftsmanship.",
      "Professional painting services for both the inside and outside of buildings, ensuring a flawless, long-lasting finish for any property.",
      "Transforming indoor spaces with expert color selection and precise application, enhancing ambiance and aesthetics.",
      "Transforming indoor spaces with expert painting services, enhancing aesthetics, and creating a refreshed, vibrant atmosphere in your home.",
    ],
    "Laser Engraving": [
      "With our Precision Metal Laser Engraving service, we turn metal surfaces into works of art. Utilizing cutting-edge technology, we etch intricate designs, text, or graphics onto various metals with unmatched detail.",
    ],
    "Paint Removal": [
      "Efficient and safe removal of old paint from surfaces, using environmentally-friendly methods and proper disposal of hazardous materials.",
    ],
    "Painting & More": [
      "Transform your space with our meticulous painting services, delivering flawless finishes and adding a fresh, vibrant appeal to your home or business.",
    ],
    "Painting & Prep": [
      "Revitalize your space with comprehensive painting and prep services, including popcorn removal, priming, and flawless interior painting for a refreshed look.",
    ],
    "Pinstriping": [
      "Step into the world of pinstriping, born from the vibrant culture of automotive and custom bike enthusiasts.",
    ],
    "Pre-Stain": [
      "Expert pre-stain preparation and application, ensuring a smooth, polished look for all woodwork, including windows and doors.",
    ],
    "Pressure Washing": [
      "Trust our top-tier pressure washing and prep work for flawless restoration, ensuring your home is ready for its stunning new paint.",
    ],
    "Refinishing": [
      "Expert refinishing services to restore and revitalize custom kitchens, bathrooms, decks, and cabinets, ensuring a stunning, like-new appearance.",
    ],
    "Refinishing Needs": [
      "Comprehensive refinishing solutions for various surfaces, restoring and enhancing the beauty and functionality of your residential spaces.",
    ],
    "Repaint": [
      "Revitalize your space with our expert repaint services, providing a fresh and updated look that reflects your style and taste.",
    ],
    "Residential": [
      "Elevate and preserve your home with our painting services. From painting the exterior walls and trim to applying protective coatings for enhanced weather resistance and durability.",
    ],
    "Residential Painting": [
      "Expert residential painting services, transforming your home with quality finishes and customized colors to suit your aesthetic preferences.",
    ],
    "Staining": [
      "Preserve and enhance wood surfaces with premium staining for long-lasting beauty and durability.",
      "Professional staining services for stairs and ceilings, ensuring a beautiful, durable, and lasting finish with meticulous attention to detail.",
    ],
    "Wall Paper Removal": [
      "Efficient wall paper removal service, carefully stripping old wall coverings to prepare surfaces for new paint or wallpaper applications.",
    ],
  },
  "plumbing": {
    "Commercial": [
      "Professional plumbing services for businesses, ensuring reliable installation, maintenance, and repair of all plumbing systems to keep operations running smoothly.",
    ],
    "Emergency": [
      "24/7 emergency plumbing services, providing immediate response and expert solutions to urgent plumbing issues to minimize damage and inconvenience.",
    ],
    "Light Plumbing": [
      "Skilled tradesperson assisting with minor plumbing and electrical tasks, including installations and basic repairs.",
    ],
    "Mechanical Piping": [
      "Design, install, and maintain mechanical piping systems for heating, cooling, and process applications, ensuring efficient and reliable operation.",
    ],
    "Replacements": [
      "Upgrade your home's comfort and efficiency with our professional plumbing water and heater replacement service.",
    ],
    "Residential": [
      "Comprehensive plumbing solutions for homes, including installation, repair, and maintenance of pipes, fixtures, and appliances to ensure comfort and functionality.",
    ],
    "Service/Repair": [
      "Our certified plumbers specialize in emergency repairs, leak detection, drain cleaning, and fixture installation.",
    ],
    "Stoppages": [
      "Our certified plumbers specialize in efficiently resolving stoppages, tackling issues ranging from minor clogs to stubborn blockages.",
    ],
    "Underground Piping": [
      "Install and maintain underground piping systems for water, gas, and sewage, ensuring reliable, efficient, and safe infrastructure.",
    ],
    "Water Heater": [
      "Our highly trained professional plumbers specialize in providing top-notch solutions for your water heating needs.",
    ],
  },
  "property-management": {
    "Property Management": [
      "Prepare properties for sale or rental with repairs, maintenance, and curb appeal enhancements for attracting buyers or tenants.",
      "We handle property management services, including cleanups, patching holes, repainting, and ensuring readiness for the next tenant with care.",
    ],
  },
  "remodeling": {
    "Additions": [
      "Expand living spaces with custom home additions, seamlessly integrating new rooms to enhance functionality and value.",
      "Expand your living space and increase your home's value with well-designed home additions that blend perfectly with your existing structure.",
      "Expand your living space seamlessly with our addition services, tailored to blend seamlessly with your existing structure while meeting your unique needs.",
      "Expert home and commercial additions, seamlessly expanding your space while maintaining structural integrity and aesthetic appeal.",
      "Seamless home additions to expand your living space, adding value and functionality to your property.",
      "Seamlessly expanding your living space with expertly designed and constructed home additions, enhancing functionality and value while blending with existing structures.",
    ],
    "Bathroom": [
      "Luxurious bathroom remodeling services, including fixtures, tiling, and vanities, to transform your bathroom into a serene and modern retreat.",
      "Renovate bathrooms with modern fixtures, elegant tiling, and efficient layouts to create luxurious and practical spaces.",
    ],
    "Bathroom Makeovers": [
      "Transforming bathrooms with fixture upgrades, tiling, and aesthetic enhancements for a renewed and stylish appearance.",
    ],
    "Bathroom Remodels": [
      "Revitalize your bathroom with our expert remodeling services offered by our team, creating a luxurious retreat tailored to your taste and comfort.",
    ],
    "Bathrooms": [
      "Expert bathroom renovations to create stylish, functional, and comfortable spaces, tailored to your needs and preferences.",
      "Renovate bathrooms, creating luxurious and practical spaces with modern fixtures, elegant tiling, and efficient layouts.",
      "Transform your commercial or residential bathroom with our remodeling and repair services, creating a functional and relaxing oasis.",
      "We offer exquisite cabinetry services for bathroom vanities, showcasing fine craftsmanship and superior materials for elegant and functional solutions.",
      "We specialize in rejuvenating bathrooms, providing expert remodeling services tailored to elevate comfort, style, and functionality.",
    ],
    "Bathtub Restoration": [
      "Professional bathtub and shower restoration using epoxy, renewing surfaces with a durable, glossy finish that extends the life of your fixtures.",
    ],
    "Build and Remodel": [
      "Build and renovate commercial and residential services, offering comprehensive services from foundation to finishing, ensuring quality and customer satisfaction.",
    ],
    "General Remodeling": [
      "We offer reliable and efficient general remodeling services to address all your needs with precision & professionalism.",
    ],
    "Interior Design": [
      "Customized interior design services to create stunning layouts for kitchens and bathrooms, blending functionality with aesthetic appeal.",
    ],
    "Kichen Remodels": [
      "Enhance your kitchen with our premier remodeling services ensuring your space reflects both your personal style and functional requirements.",
    ],
    "Kitchen": [
      "Design and remodel kitchens, improving functionality and style with custom cabinetry, countertops, appliances, and innovative storage solutions.",
    ],
    "Kitchen Makeovers": [
      "Enhancing kitchens through renovations, including cabinetry, countertops, appliances, and design enhancements for a refreshed look.",
    ],
    "Kitchen/Bath": [
      "Transform your kitchen and bathroom into stunning spaces with our expert construction services.",
    ],
    "Kitchens": [
      "Comprehensive kitchen remodeling services to create your dream culinary space, improving layout, functionality, and design.",
      "Comprehensive kitchen remodeling services to enhance design, improve functionality, and create your dream culinary space.",
      "Upgrade your commercial or residential kitchen or breakroom with our craftsmanship, tailored to enhance efficiency and aesthetics.",
      "We excel in transforming kitchens, offering top-notch remodeling services that enhance functionality and aesthetics to suit your lifestyle.",
      "We provide premium kitchen cabinetry services, crafting tailor-made solutions with high-quality materials and meticulous craftsmanship for exceptional results.",
    ],
    "Remodel": [
      "Transform existing spaces with high-quality renovation services, enhancing functionality, aesthetics, and value for residential and commercial properties.",
      "Transform spaces with customized design and construction, enhancing layout, style, and usability to meet your specific needs and preferences.",
    ],
    "Remodels": [
      "Complete home remodeling services to modernize and enhance the functionality and aesthetics of your living spaces.",
      "Expert drywall solutions for new builds and remodeling projects, ensuring a flawless finish that enhances the structural integrity and visual appeal of any space.",
      "Our skilled team is dedicated to bringing your vision to life, whether you're renovating a bathroom, kitchen, or an entire home.",
      "Transform kitchens and bathrooms with expert remodeling, enhancing functionality, style, and value through innovative designs and quality craftsmanship.",
      "Transform your home with our exceptional carpentry services for home remodels, crafting custom cabinetry, trim, shelving, and more to your exact specifications.",
      "Transform your space with our comprehensive remodeling services, including luxurious bathroom and kitchen upgrades and room additions.",
      "Transform your space with our expertise in remodels and renovations, enhancing functionality, aesthetics, and overall value.",
      "We breathe new life into your spaces with our remodels and restoration services. Whether you're revitalizing a historic property or modernizing your home, our expert team delivers impeccable craftsmanship and attention.",
    ],
    "Remodels & More": [
      "Revitalize your home with our comprehensive services: remodels, drywall installation, custom deck construction, and complete bathroom and kitchen renovations.",
    ],
    "Remodels and Additions": [
      "Trust our experienced team to handle your remodeling and addition projects, delivering exceptional craftsmanship and transforming your residential or commercial space according to your specifications.",
    ],
    "Renovation": [
      "Professional renovation services, transforming and updating your existing spaces with innovative designs and high quality construction techniques.",
      "Revitalize and update existing structures, improving functionality and aesthetics with expert craftsmanship and high-quality materials for lasting results.",
      "Revitalize your home with expert craftsmanship, attention to detail, and a focus on enhancing aesthetics and functionality.",
    ],
    "Repair and Additions": [
      "Ensure the longevity of your property with our professional structural repair solutions and seamless building additions for enhanced functionality.",
    ],
    "Walls": [
      "Professional wall building and restoration, offering robust and aesthetically pleasing solutions for interior and exterior spaces.",
    ],
    "Wood Restoration": [
      "Professional restoration for wood surfaces, improving the appearance and extending the lifespan of various wooden structures.",
    ],
  },
  "roofing": {
    "Asphalt Shingles": [
      "High-quality asphalt shingles and metal roofing for residential properties, providing long-lasting protection, energy efficiency, and enhanced curb appeal.",
    ],
    "Commercial": [
      "Specialized commercial roofing solutions designed to meet the demands of businesses, with durable materials and efficient installation for any commercial structure.",
    ],
    "Commercial Roofing": [
      "Our commercial roofing service delivers expert solutions, ensuring durability, efficiency, and unmatched quality for all your business roofing needs.",
    ],
    "Consulting": [
      "Offer expert roofing consulting services, providing guidance on materials, design, and solutions to optimize roof performance and longevity.",
    ],
    "Gutters": [
      "Seamless gutter installation and maintenance to protect your property by efficiently directing water away from your roof and foundation.",
    ],
    "Hot Applied Roofs": [
      "Innovative hot-applied systems provide seamless, durable waterproofing solutions for commercial and industrial roofing projects.",
    ],
    "Inspections": [
      "Conduct thorough roof inspections to assess condition, identify issues, and provide detailed reports for maintenance or repair needs.",
    ],
    "Installation": [
      "We combine roofing expertise with careful installation practices. We understand that a reliable and well-crafted roof is the foundation of a secure and comfortable home or business.",
    ],
    "Membrane Roofs": [
      "Reliable EPDM and TPO membranes offer superior weather resistance, energy efficiency, and long-lasting protection for flat and low-slope roofing systems.",
    ],
    "Metal Roofs": [
      "Versatile metal roofing options blend durability, energy efficiency, and customizable styles for homes and businesses requiring high-performance solutions.",
    ],
    "New Roofs": [
      "Professional installation of durable and stylish roofs for residential and commercial properties, enhancing aesthetic appeal and providing superior protection.",
    ],
    "Repair": [
      "In the realm of safeguarding your home or business, our team, stands as the beacon of reliable and adept roofing repair services.",
    ],
    "Repairs & Reroof": [
      "Perform roof repairs and complete reroofing, ensuring long-lasting protection and durability for residential and commercial properties.",
    ],
    "Reroof": [
      "Reliable reroofing services that refresh and strengthen existing roofs, ensuring long-lasting protection and a fresh, updated look.",
    ],
    "Reroofs": [
      "Expert reroofing services to replace worn or damaged roofs, ensuring durability, safety, and aesthetic appeal for your home.",
    ],
    "Residential Re-Roofs": [
      "Specializing in full roof replacements, we enhance durability and curb appeal with expert craftsmanship tailored to your home.",
    ],
    "Residential Roofing": [
      "Our residential roofing service provides reliable, high-quality solutions, ensuring the safety and longevity of your home with expert craftsmanship.",
    ],
    "Roof Repairs": [
      "Reliable and efficient repairs for residential and commercial properties, addressing leaks, damage, and any issues affecting the integrity of your roof.",
    ],
    "Roofing and Siding": [
      "Expert roofing and siding services to protect and beautify your home, ensuring durability, weather resistance, and curb appeal.",
    ],
    "Screw Down Metal": [
      "A cost-effective metal roofing solution offering durability and strength. Ideal for residential and commercial applications, providing excellent weather resistance and long-lasting protection.",
    ],
    "Shake Roofs": [
      "Durable, traditional wood or modern synthetic shake roofs provide a timeless aesthetic while ensuring lasting protection against the elements.",
    ],
    "Standing Seam": [
      "Premium metal roofing with sleek, modern aesthetics. Its concealed fasteners ensure superior water resistance, making it perfect for areas with harsh weather conditions.",
    ],
    "Synthetic Slate Roofs": [
      "Advanced synthetic slate offers the elegance of natural stone with enhanced durability and reduced weight, ideal for a refined architectural look.",
    ],
    "Underdeck Waterproofing": [
      "Maximize your deck’s utility with underdeck waterproofing, creating dry, usable space beneath your deck for storage or leisure.",
    ],
  },
  "snow-removal": {
    "Ice and Snow": [
      "Reliable ice and snow removal services to keep your property safe and accessible during winter.",
    ],
    "Plowing Mowing": [
      "Providing reliable plowing and mowing services to maintain and enhance the appearance and accessibility of your property year-round.",
    ],
    "Snow Plowing": [
      "Our snow plowing services swiftly clear snow from driveways and walkways, ensuring safe passage during winter weather conditions with reliable efficiency.",
    ],
    "Snow Rails and Diverters": [
      "Protective snow rails and diverters help manage snow runoff, safeguarding your roof and property during harsh winter conditions.",
    ],
  },
  "tile-stone": {
    "Custom Showers": [
      "We specialize in premium tile and stone installations, providing expert craftsmanship and personalized designs for custom shower projects.",
    ],
    "Stonework": [
      "Skilled stonework services for patios, walkways, and decorative features, adding elegance and functionality to your outdoor spaces.",
    ],
    "Tile": [
      "We take pride in delivering unparalleled excellence in tile work. Our skilled craftsmen combine precision and creativity to transform spaces with intricate patterns and stunning designs.",
    ],
    "Tile/Luxury Vinyl Tile": [
      "From the timeless elegance of conventional tile to the contemporary versatility of Luxury Vinyl Tile, our showroom invites you to explore both.",
    ],
  },
  "welding": {
    "Fabrication": [
      "Tailored fabrication of custom vehicle and industrial components, with expertise in butterfly valves. Precision engineering for your specific needs.",
    ],
    "Rusted Frame Repairs": [
      "Specializing in rusted frame repairs for vehicles. Professional restoration, ensuring safety and longevity for your vehicle's structural integrity.",
    ],
    "Welding": [
      "Discover the pinnacle of metal fusion through our specialized welding services, where expertise and innovation converge to realize your projects' full potential.",
      "Precision welding services for engines, industrial machinery, and more. Expert craftsmanship, durability, and efficiency for your welding needs.",
    ],
  },
}

export const TRADE_COPY = {
  "carpentry": [
    "Experience the craftsmanship of our carpenters who specialize in building stunning decks, creating seamless room additions, installing exquisite hardwood flooring and etc.",
    "Our in-house carpentry services epitomize precision and craftsmanship, bringing your vision to life with meticulous attention to detail.",
    "Transforming spaces with expert carpentry: tailored designs, durable materials, precise installations, and reliable repairs for stunning transformations every time.",
  ],
  "cleaning": [
    "Experience the transformative touch of our skilled technicians, dedicated to enhancing the cleanliness and longevity of your carpets and upholstery.",
  ],
  "concrete": [
    "Install and repair concrete structures, including driveways, patios, and foundations, ensuring durability, strength, and a polished finish.",
    "Pour and finish concrete surfaces such as driveways, sidewalks, and patios, providing durable and smooth foundations for various applications.",
    "Provide expert concrete services, including pouring, finishing, and repairs, ensuring durable and high-quality surfaces for various applications.",
  ],
  "demolition": [
    "Safe and precise demolition of small structures, including sheds, walls, and decks, with thorough debris removal and cleanup.",
  ],
  "drywall": [
    "Comprehensive drywall services, including installation, repairs, and finishing, to provide a seamless and polished look for your walls and ceilings.",
    "Transform your home with expert drywall installation, repair, and finishing services tailored to elevate your living space's aesthetic and functionality.",
    "We specialize in providing exceptional drywall services, ensuring flawless installations and repairs for residential and commercial properties.",
  ],
  "electrical": [
    "Installations, repairs, and upgrades for safe and efficient electrical systems, provided by licensed and insured professionals.",
    "We provide comprehensive electrical solutions. Our expertise includes retrofitting to energy-efficient LED fixtures, outlet and switch installations, lighting adjustments, and circuit troubleshooting for seamless.",
  ],
  "excavation": [
    "Perform precise excavation work for foundations, utilities, and landscaping, ensuring safe and efficient site preparation.",
    "Providing professional excavation and grading services to manage water flow, adding or removing soil to prevent water damage and ensure proper drainage.",
  ],
  "fencing": [
    "Customized fencing solutions for enhanced security and privacy, tailored to your specific requirements.",
    "Customized fencing solutions provide enhanced security and privacy, meticulously tailored to meet your specific requirements and preferences.",
    "Durable and attractive fences for enhanced security and privacy, tailored to residential and commercial needs.",
  ],
  "flooring": [
    "Elevate your space with our premium flooring services. Whether you lean towards the timeless allure of hardwood or the enduring resilience of tile, we specialize in flawless installation and meticulous craftsmanship.",
  ],
  "handyman": [
    "Our comprehensive handyman services include expert drywall work, fence installation, and precise patching, ensuring your home projects are completed flawlessly.",
    "Skilled professional offering various repair and maintenance services for homes or commercial properties.",
    "Versatile handyman service offering popcorn removal and installation services. Skilled in various home repairs, providing efficient and reliable solutions.",
    "We offer versatile solutions for home repairs, maintenance and installations ensuring peace of mind for homeowners.",
  ],
  "hvac": [
    "Comprehensive HVAC services delivering efficient heating, ventilation, and air conditioning solutions with skilled technicians ensuring comfort and satisfaction.",
  ],
  "landscaping": [
    "Design and maintain outdoor spaces, including gardens, lawns, and hardscapes, to enhance beauty, functionality, and property value.",
    "Enhance your outdoor spaces with our landscaping services. We offer weekly maintenance, including lawn care and debris removal, along with tree trimming, removal, and replacement.",
  ],
  "painting": [
    "Experience the transformative power of metal painting where every stroke is a testament to precision and artistry.",
    "Expertly transform interiors and exteriors, revitalizing spaces with flawless finishes, enhancing appeal and property value.",
    "High-quality interior and exterior painting services to enhance aesthetics, protect surfaces, and add value to residential and commercial properties.",
    "Our interior painting service delivers flawless finishes, vibrant colors, meticulous attention to detail, and a transformative touch to any space.",
    "Our painting service revitalizes spaces with expert color selection, meticulous preparation, and flawless execution, transforming your vision into reality.",
    "Professional painting services for interiors and exteriors, providing high-quality finishes that enhance the beauty and durability of your property.",
    "Professional residential painting services for interiors and exteriors, providing flawless finishes that refresh and protect your home’s appearance.",
    "Refresh your commercial or residential space with our high-quality painting services, adding a new layer of beauty and vibrancy.",
    "We offer expert painting services for homes and businesses, enhancing spaces with professional finishes.",
    "We provide expert painting services, including paint matching repaired areas and painting entire or partial rooms for an additional charge.",
  ],
  "plumbing": [
    "Expert plumbers providing reliable repairs, installations, and maintenance with prompt service and exceptional customer care for your plumbing needs.",
    "Licensed and insured, we offer installations, repairs, and maintenance to keep your plumbing systems in optimal condition.",
    "Our plumbing services are the cornerstone of our commitment to your home's functionality and convenience.",
    "We provide comprehensive plumbing solutions, including basic repairs for toilets, faucets, and leaks, as well as mainline repairs, leak detection, drainage cleaning, and irrigation system services.",
  ],
  "property-management": [
    "Prepare properties for sale or rental with repairs, maintenance, and curb appeal enhancements for attracting buyers or tenants.",
    "We handle property management services, including cleanups, patching holes, repainting, and ensuring readiness for the next tenant with care.",
  ],
  "remodeling": [
    "Comprehensive remodeling services to transform spaces, blending functionality and style to create personalized and inviting environments for clients.",
    "Expert remodeling services transforming bathrooms and kitchens with innovative designs, quality materials, and impeccable craftsmanship. Enhancing functionality and aesthetics.",
    "Professional remodeling solutions to transform your home, specializing in full bathroom remodels with upgraded showers, tubs, and walk-in tubs.",
    "Transform your home with our remodeling services, including kitchen and bathroom renovations, room additions, and interior upgrades tailored to your vision.",
    "Transforming spaces with expert remodeling services, enhancing functionality and aesthetics to meet your vision and needs.",
    "Trust our expertise for top-notch remodeling on hardwood and tile. We pride ourselves on delivering the best craftsmanship to restore the beauty of your surfaces.",
  ],
  "roofing": [
    "Expert roofing services for residential and commercial properties, ensuring durable, weather-resistant solutions with a focus on quality craftsmanship.",
    "Professional roofing services providing installation, repair, and maintenance for residential and commercial properties. Ensuring durable, weatherproof, and aesthetically pleasing roofs.",
    "Reliable roofing installation and repair, using high-quality materials to ensure durability and long-lasting protection.",
    "We provide roofing services. Our skilled team specializes in expert installations and repairs, ensuring the utmost quality and durability for your home.",
  ],
}

/** Every service this trade offers, in the order the drop listed them. */
export function servicesFromCopy(slug) {
  return Object.keys(SERVICE_COPY[slug] || {})
}

/** Words too common to mean two services are the same thing. */
const WEAK = new Set([
  "and", "the", "of", "for", "with", "a", "an", "to", "in", "on",
  "service", "services", "work", "general", "custom", "new", "other",
])

const wordsOf = value =>
  String(value || "")
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(word => word.length > 2 && !WEAK.has(word))

/**
 * Every wording on file for one service — FCS-079.
 *
 * Three passes, narrowing:
 *
 *   1. the exact name
 *   2. the same name in different case, since a hand-typed service will not
 *      match a title-cased key
 *   3. a RELATED service in the same trade — the drop was written by real
 *      contractors, who called it "Service/Repair" where the builder offers
 *      "Leak Repair". Without this a curated service name falls through to
 *      the sentence this file assembles from its own words, which is exactly
 *      what FCS-079 is about: the descriptions should come from the drop.
 *
 * The third pass requires a SHARED SIGNIFICANT WORD — "repair" matches
 * "repair", "roofing" does not match "plumbing" — because a description
 * about the wrong job is worse on a contractor's website than a plainer one
 * about the right job. Common words are excluded for the same reason: every
 * entry contains "service", and matching on it would attach any description
 * to anything.
 */
export function copyVariants(slug, service) {
  const forTrade = SERVICE_COPY[slug] || {}

  const exact = forTrade[service]
  if (exact && exact.length > 0) return exact

  const wanted = String(service || "").trim().toLowerCase()
  const sameName = Object.keys(forTrade).find(name => name.toLowerCase() === wanted)
  if (sameName) return forTrade[sameName]

  const mine = wordsOf(service)
  if (mine.length === 0) return []

  const related = Object.keys(forTrade)
    .map(name => {
      const theirs = wordsOf(name)
      const shared = mine.filter(word => theirs.includes(word)).length
      return { name, shared }
    })
    .filter(match => match.shared > 0)
    .sort((a, b) => b.shared - a.shared)

  // Every wording from every related service, best match first, so the
  // regenerate button has something to offer rather than one take-it-or-
  // leave-it line.
  const out = []
  for (const match of related) {
    for (const copy of forTrade[match.name]) {
      if (!out.includes(copy)) out.push(copy)
    }
  }
  return out
}
